var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rbvp-section-content" }, [
    !_vm.state.rbvpEnabled
      ? _c("div", { staticClass: "rbvp-namespace-disabled-banner" }, [
          _c("div", { staticClass: "rbvp-namespace-disabled-banner-title" }, [
            _vm._v("RBVP 组件当前已关闭"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rbvp-namespace-disabled-banner-text" }, [
            _vm._v(
              "\n      即使存在已注册且已接管的命名空间，RBVP 也不会生效。请先在组件设置中启用 RBVP。\n    "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "rbvp-guide-card" }, [
      _c("div", { staticClass: "rbvp-guide-title" }, [_vm._v("命名空间")]),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-guide-text" }, [
        _vm._v(
          "\n      这里展示 RBVP 当前已注册的命名空间，可查看主名称、描述并自定义别名。别名会写入主规则文本的\n      @alias\n      指令，规则动作里既可以使用主名称，也可以使用别名；若该命名空间支持接管开关，也可以直接在这里切换，并同步写回对应组件设置。\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-guide-meta" }, [
        _c("span", [
          _vm._v(
            "当前共 " + _vm._s(_vm.state.namespaceItems.length) + " 个命名空间"
          ),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("别名写入主规则文本的 @alias 指令")]),
      ]),
    ]),
    _vm._v(" "),
    _vm.state.namespaceItems.length === 0
      ? _c("div", { staticClass: "rbvp-empty-state rbvp-namespace-empty" }, [
          _c("div", { staticClass: "rbvp-empty-state-title" }, [
            _vm._v("还没有已注册的命名空间"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rbvp-empty-state-text" }, [
            _vm._v(
              "\n      请先启用带 RBVP 兼容能力的组件或插件，注册成功后会自动出现在这里。\n    "
            ),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "rbvp-namespace-list" },
          _vm._l(_vm.state.namespaceItems, function (item) {
            return _c(
              "div",
              { key: item.name, staticClass: "rbvp-namespace-card" },
              [
                _c("div", { staticClass: "rbvp-namespace-header" }, [
                  _c("div", { staticClass: "rbvp-namespace-title-area" }, [
                    _c("div", { staticClass: "rbvp-section-title" }, [
                      _vm._v(_vm._s(item.displayName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rbvp-namespace-takeover" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "rbvp-namespace-takeover-status",
                          class: {
                            active: item.takeoverState && item.componentEnabled,
                            disabled: !item.componentEnabled,
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                !item.componentEnabled
                                  ? "组件已关闭"
                                  : item.takeoverState
                                  ? "RBVP 已接管"
                                  : "RBVP 未接管"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      item.componentEnabled
                        ? _c("SwitchBox", {
                            attrs: { checked: item.takeoverState },
                            on: {
                              change: function ($event) {
                                return _vm.actions.toggleNamespaceTakeover(item)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "rbvp-namespace-description" }, [
                  _vm._v(_vm._s(item.description)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "rbvp-namespace-alias-area" }, [
                  _c(
                    "div",
                    { staticClass: "rbvp-namespace-tags" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "rbvp-namespace-name-tag",
                          attrs: { title: item.name },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "rbvp-namespace-name-flag" },
                            [_vm._v("主名称")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "rbvp-namespace-tag-text" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c("VIcon", {
                            staticClass: "rbvp-namespace-name-lock",
                            attrs: { icon: "mdi-lock", size: 12 },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(item.aliases, function (alias) {
                        return _c(
                          "span",
                          {
                            key: `${item.name}-${alias}`,
                            staticClass: "rbvp-namespace-tag",
                            attrs: { title: alias },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "rbvp-namespace-tag-text" },
                              [_vm._v(_vm._s(alias))]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "rbvp-namespace-tag-remove",
                                attrs: { type: "button", title: "移除别名" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.actions.removeNamespaceAlias(
                                      item,
                                      alias
                                    )
                                  },
                                },
                              },
                              [
                                _c("VIcon", {
                                  attrs: { icon: "close", size: 12 },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.aliasEditing !== item.name
                        ? _c(
                            "button",
                            {
                              staticClass: "rbvp-namespace-alias-add",
                              attrs: { type: "button", title: "添加别名" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.startAliasInput(item.name)
                                },
                              },
                            },
                            [
                              _c("VIcon", {
                                attrs: { icon: "mdi-plus", size: 16 },
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("添加别名")]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.aliasEditing === item.name
                        ? _c(
                            "div",
                            { staticClass: "rbvp-namespace-alias-input-row" },
                            [
                              _c("TextBox", {
                                ref: "aliasInput",
                                refInFor: true,
                                staticClass: "rbvp-namespace-alias-input",
                                attrs: {
                                  text: _vm.aliasInputs[item.name] ?? "",
                                  placeholder: "添加别名",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setAliasInput(item.name, $event)
                                  },
                                },
                                nativeOn: {
                                  keyup: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.submitAlias(item)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      return _vm.cancelAliasInput(item.name)
                                    },
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "VButton",
                                {
                                  staticClass: "rbvp-namespace-alias-confirm",
                                  attrs: {
                                    type: "primary",
                                    icon: "",
                                    title: "确认",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.submitAlias(item)
                                    },
                                  },
                                },
                                [
                                  _c("VIcon", {
                                    attrs: { icon: "mdi-check", size: 14 },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "VButton",
                                {
                                  staticClass: "rbvp-namespace-alias-cancel",
                                  attrs: { icon: "", title: "取消" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cancelAliasInput(item.name)
                                    },
                                  },
                                },
                                [
                                  _c("VIcon", {
                                    attrs: { icon: "close", size: 12 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }